import { Routes, Route, Navigate, useParams } from "react-router";
import LoginPage from "../pages/auth/LoginPage";
import DashboardLayout from "../layouts/DashboardLayout";
import DashboardHome from "../pages/dashboard/DashboardHome";
import PortfoliosPage from "../pages/dashboard/PortfoliosPage";
import PortfolioUploadPage from "../pages/dashboard/PortfolioUploadPage";
import PortfolioUploadRecordsPage from "../pages/dashboard/PortfolioUploadRecordsPage";
import PortfolioGroupCasesPage from "../pages/dashboard/PortfolioGroupCasesPage";
import CustomersPage from "../pages/dashboard/CustomersPage";
import CasesPage from "../pages/dashboard/CasesPage";
import PaymentsPage from "../pages/dashboard/PaymentsPage";
import ReportsPage from "../pages/dashboard/ReportsPage";
import ReportDetailPage from "../pages/dashboard/ReportDetailPage";
import SettingsPage from "../pages/dashboard/SettingsPage";
import AuditTrailPage from "../pages/dashboard/AuditTrailPage";
import ProtectedRoute, { GuestRoute } from "./ProtectedRoute";

function ReportRoute() {
  const { slug } = useParams();
  return <ReportDetailPage key={slug} />;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route
        path="/login"
        element={
          <GuestRoute>
            <LoginPage />
          </GuestRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardHome />} />
        <Route path="portfolios" element={<PortfoliosPage />} />
        <Route path="portfolios/:groupId/upload" element={<PortfolioUploadPage />} />
        <Route path="portfolios/:groupId/cases" element={<PortfolioGroupCasesPage />} />
        <Route path="portfolios/:groupId/uploads/:uploadId" element={<PortfolioUploadRecordsPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="segments" element={<Navigate to="/dashboard/customers" replace />} />
        <Route path="cases" element={<CasesPage />} />
        <Route path="assignment" element={<Navigate to="/dashboard/cases" replace />} />
        <Route path="communications" element={<Navigate to="/dashboard/payments" replace />} />
        <Route path="contact-centre" element={<Navigate to="/dashboard/payments" replace />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="escalations" element={<Navigate to="/dashboard" replace />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="reports/:slug" element={<ReportRoute />} />
        <Route path="users" element={<Navigate to="/dashboard" replace />} />
        <Route path="team" element={<Navigate to="/dashboard" replace />} />
        <Route path="roles" element={<Navigate to="/dashboard" replace />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="audit-trail" element={<AuditTrailPage />} />
        <Route path="activity" element={<Navigate to="/dashboard/audit-trail" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
